module.exports = __webpack_public_path__ + "img/game5.f1e34660.png";